import { render, staticRenderFns } from "./CompanyDistributionListList.vue?vue&type=template&id=5e76a963&scoped=true&"
import script from "./CompanyDistributionListList.vue?vue&type=script&lang=js&"
export * from "./CompanyDistributionListList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e76a963",
  null
  
)

export default component.exports